import React from "react";
import {connect} from "react-redux";
import restService from "@assecobs/react-utils/restService";
import {injectIntl} from "react-intl";
import {REQUEST_ERROR} from "@assecobs/react-utils/common/Events";
import {ERROR_TOAST, toast} from "assecobs-faktor-web-common/toasts/ToastInitializer";

class AjaxErrorLog extends React.Component {

    componentWillMount() {
        restService.on(REQUEST_ERROR, async (response) => {
            const data = await response.json();
            toast(ERROR_TOAST({
                bodyText: data.message || this.props.intl.formatMessage({id: "fw.error.body"})
            }));
        })
    }

    componentWillUnmount() {
        restService.off(REQUEST_ERROR);
    }

    render() {
        return null;
    }

}

export default connect()(injectIntl(AjaxErrorLog));

